/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_IT = {
  "  Checked by (signature)": "  Verificato da (firma)",
  "! 3 of 4 types required:": "! 3 tipi su 4 richiesti:",
  "! Min. 14 characters": "! Min. 14 caratteri",
  "! No name/username parts": "! Nessuna parte di nome/nome utente",
  "! No spaces": "! Nessuno spazio",
  "/ occasion": "/ occasione",
  "A new password should be different than the current one": "Una nueva contraseña debe ser diferente a la actual",
  "ACCEPTED": "ACCETTATO",
  "Active flights": "Voli attivi",
  "Add deicing/anti-icing": "Aggiungi deicing/anti-icing",
  "Add description": "Aggiungere la descrizione",
  "Add description if there is a irregularity!": "Aggiungi una descrizione se c'è un'irregolarità!",
  "Add line": "Aggiungere la linea",
  "Add location where item was found": "Aggiungere il luogo in cui è stato trovato l'oggetto",
  "Add note": "Aggiungi nota...",
  "add occasion": "aggiungere un'occasione",
  "Add other location": "Aggiungi un'altra posizione",
  "Add row": "Aggiungere la fila",
  "Add storage location": "Aggiungere il luogo di deposito",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Aggiungi la tua email di recupero così possiamo mandarti un codice se dimentichi la password.",
  "additional services": "Servizi aggiuntivi",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Dopo aver cliccato 'CONFERMA', la correzione MVT verrà inviata. Può essere reinviata se c'è un cambiamento in ALDT o/ed AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Dopo aver cliccato 'CONFERMA', l'MVT verrà inviato. Può essere reinviato se c'è un cambiamento in ALDT o/ed AIBT.",
  "Agent's name:": "Nome dell'agente:",
  "Agent's signature:": "Firma dell'agente:",
  "Aircraft Damage": "Danni all'aeromobile",
  "Aircraft type": "Tipo di aeromobile",
  "Airline": "Compagnia aerea",
  "All": "Tutti",
  "ALL": "TUTTI",
  "All Airlines with Stocks": "Tutte le compagnie con stock",
  "An error occurred while trying to verify your email address.": "Si è verificato un errore durante il tentativo di verificare il tuo indirizzo email.",
  "and": " e ",
  "and/or": "e/o",
  "Anti-icing": "Anti-icing",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Qualsiasi email con @aviapartner.aero o @aviavip.com non è accettata!",
  "APPLY": "APPLICARE",
  "approved": "approvato",
  "Apr": "Apr",
  "Archived": "Archiviato",
  "Are you sure you want to change your password?": "Sei sicuro di voler cambiare la password?",
  "Are you sure you want to exit the current process?": "Sei sicuro di voler uscire dal processo in corso?",
  "Are you sure you want to remove photo?": "Sei sicuro di voler rimuovere la foto?",
  "Are you sure you want to sign out?": "Sei sicuro di voler firmare?",
  "area": "zone",
  "Arrival MVT has been sent": "MVT in arrivo è stato inviato",
  "Arrival MVT not sent yet": "MVT in arrivo non ancora inviato",
  "Arrival MVT sending": "Invio del MVT in arrivo",
  "Arrival MVT sent successfully": "Arrivo MVT inviato con successo",
  "Attach photo": "Allega foto",
  "Attachment": "Allegato",
  "Aug": "Ago",
  "Available": "Disponibile",
  "Belt": "Cintura",
  "Body": "Corpo",
  "Briefly describe where the item will be stored for picking up.": "Descrivere brevemente il luogo in cui l'articolo sarà depositato per il ritiro.",
  "Call {{firstName}} {{lastName}}": "Chiama {{firstName}} {{lastName}}",
  "Call sign": "Call sign",
  "Cancel": "Annulla",
  "CANCEL": "CANCELLARE",
  "Cannot be after": "Non può essere dopo ",
  "Cannot be before": "Non può essere prima ",
  "Cannot create MVT message: missing flight information": "Non posso creare il messaggio di MVT: informazioni del volo mancanti",
  "Cannot send Arrival MVT": "Impossibile inviare MVT in arrivo. Destinatari (SITA e/o email) per questo volo non configurati in Sunrise.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Impossibile inviare l'Arrivo MVT. Gli indirizzi (SITA e/o email) per questo volo non sono configurati in Sunrise.",
  "Cannot send MVT ETD": "Impossibile inviare MVT ETD. Destinatari (SITA e/o email) per questo volo non configurati in Sunrise.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Impossibile inviare l'MVT ETD. Gli indirizzi (SITA e/o email) per questo volo non sono configurati in Sunrise.",
  "Cannot set a future time.": "Non è possibile impostare un orario futuro.",
  "Change": "Cambia",
  "Change password": "Cambiare la password",
  "Change password?": "Cambiare la password?",
  "Change your password:": "Modifica la password:",
  "Checked by (signature)": "Controllato da (firma)",
  "Checks on easily visible parts of the aircraft from the ground": "Controlli sulle parti dell'aeromobile facilmente visibili da terra:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Controlli su parti facilmente visibili dell'aereo dal suolo. Nessun danno o anomalia evidente a:",
  "Chocks": "Strozzatori",
  "Chute": "Chute",
  "CLEAR": "Chiaro",
  "Client's signature:": "Firma del cliente:",
  "Clocked Time": "Ora registrata",
  "Close": "Chiudere",
  "CLOSE": "CHIUDI",
  "Close all my sessions on all devices": "Chiudi tutte le mie sessioni su tutti i dispositivi",
  "Close registration": "Chiudere la registrazione",
  "CLOSE REGISTRATION": "CHIUDI REGISTRAZIONE",
  "close the flight": "chiudere il volo",
  "Closed": "Chiuso",
  "Closing this window will discard all your recent changes.": "La chiusura di questa finestra annullerà tutte le modifiche recenti.",
  "Clouds": "Nuvole",
  "Comment": "Commento",
  "Comment...": "Commento...",
  "Comments": "Commenti",
  "Completed": "Completato",
  "Conditional services": "Servizi condizionati",
  "Cones": "Coni",
  "CONFIRM": "CONFERMARE",
  "Confirm": "Confermare",
  "Confirm new password": "Conferma la nuova password",
  "Confirm remove?": "Confermare la rimozione?",
  "CONFIRMED": "CONFERMATO",
  "Contact your administrator to request access": "Contatta il tuo amministratore per richiedere l'accesso",
  "Could not save data, please try again later": "Impossibile salvare i dati, riprova più tardi",
  "Crew signature": "FIRMA CREW",
  "Current password": "Password attuale",
  "Damage": "Danno",
  "Date range": "Intervallo di date",
  "Date should not be before start date": "La data non deve essere precedente alla data di inizio",
  "Day": "Giorno",
  "Dec": "Dic",
  "DECLINED": "DECLINATO",
  "Default station": "Stazione predefinita",
  "Deicing": "Disgelo",
  "Deicing Service Registration": "Registrazione al servizio di sghiacciamento",
  "Delete Photo": "Elimina foto",
  "DENIED": "NEGATO",
  "Describe location": "Descrivere la posizione",
  "Dest.": "Dest.",
  "Destination": "Destinazione",
  "Did you forget something?": "Hai dimenticato qualcosa?",
  "Don't use phone while driving!": "Non usare il telefono mentre si guida!",
  "Dummy Type": "Tipo di manichino",
  "Edit Comment": "Modifica commento",
  "Emergency": "Emergenza",
  "Emergency contacts are not set up": "I contatti di emergenza non sono impostati.",
  "employees": "Dipendenti",
  "End": "Fine",
  "End of anti-icing": "Fine della anti-congelazione",
  "End Time": "Tempo della fine",
  "End time should not be before start time": "L'ora di fine non dovrebbe essere prima dell'ora di inizio",
  "Entrance": "Ingresso",
  "Error loading clocked times": "Errore durante il caricamento delle ore registrate",
  "Error. The email doesn't meet standard formatting.": "Errore. L'email non soddisfa il formato standard.",
  "exceeds the allowed limit for this flight": " supera il limite consentito per questo volo.",
  "Executor's name:": "Nome dell'esecutore testamentario:",
  "Executor's signature:": "Firma dell'esecutore testamentario:",
  "extra service": "Servizi extra",
  "Extra services": "Servizi extra",
  "Extra shift request": "Richiesta di turno extra",
  "Extra Shift Request": "Richiesta di turno extra",
  "Extra shift request confirmed": "Richiesta di turno extra confermata",
  "failed": "fallito",
  "Feb": "Feb",
  "Filter": "Filtro",
  "Filter group": "Gruppo filtro",
  "Filter group has not been updated": "Il gruppo di filtri non è stato aggiornato",
  "filter group not found": "gruppo filtro non trovato",
  "finalization": "finalizzazione",
  "Find the account recovery section and click \"Resend verification email\".": "Trova la sezione di recupero dell'account e fai clic su \"Reinvia email di verifica\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: Un documento non può essere scritto perché supera la dimensione massima consentita",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Un documento non può essere scritto perché supera la dimensione massima consentita",
  "Flight": "Vol",
  "Flight details": "Dettagli del volo",
  "Flight information registration": "Registrazione delle informazioni sul volo",
  "Flight not found": "Volo non trovato",
  "Flight number/registration": "Numero di volo/registrazione",
  "Flight registration is closed": "La registrazione del volo è chiusa.",
  "Flight reopened": "Volo riaperto",
  "Flight type": "Tipo di volo",
  "Flights": "Voli",
  "Fluid name": "Nome del fluido",
  "Fluid name:": "Nome del fluido:",
  "Fluid type": "Tipo di fluido",
  "Forgot your password?": "Hai dimenticato la tua password?",
  "Forms": "Moduli",
  "from": "da",
  "From": "Da",
  "Full (Wings, stabilizer &, fuselage)": "Completo (Ali, stabilizzatore e fusoliera)",
  "Future time is not allowed": "Il tempo futuro non è permesso",
  "Gate": "Gate",
  "General info": "Informazioni generali",
  "Go to flights": "Vai ai voli",
  "Go to login": "Vai al login",
  "Go to My Profile in your Sunrise account.": "Vai al mio profilo nel tuo account Sunrise.",
  "Go to Unread R&S": "Vai a R&S non letti",
  "Helpdesk": "Helpdesk",
  "Hold Inspection on Arrival": "Ispezione della stiva arrivo",
  "Hold Inspection on Departure": "Ispezione della stiva partenza",
  "hr": "hr",
  "Humidity": "Umidità",
  "If damage is found, mark it on the sketch": "Se si trova un danno, contrassegnalo sul disegno",
  "If the problem continues, go to My Profile to resend a new verification link.": "Se il problema persiste, vai al mio profilo per reinviare un nuovo link di verifica.",
  "In order to close this flight you need to provide": "Per chiudere questo volo è necessario fornire dettagli obbligatori.",
  "In order to close this flight you need to provide mandatory details.": "Per chiudere questo volo è necessario fornire dettagli obbligatori.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Per potere aprire 'Calendar', leggere e processare i messaggi Read & Sign recenti.",
  "In order to send Arrival MVT you need to provide mandatory details": "Per potere inviare il MVT in arrivo, bisogna fornire i dettagli obbligatori",
  "Include nearby area": "Includere la zona circostante",
  "Included nearby area": "Inclusa la zona circostante",
  "Incorrect code": "Codice errato",
  "Input a brief description here": "Inserisci una breve descrizione qui",
  "Inspected by": "Ispezionato da",
  "Inspection agent's signature": "Firma dell'agente di ispezione",
  "Inspection agent's signature:": "Firma dell'agente di controllo:",
  "Inspections": "Ispezioni",
  "Instructions": "Istruzioni",
  "Internal communication": "Comunicazione interna",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Valore ALDT/AIBT non valido o MVT in arrivo con questi ALDT e AIBT già esistente",
  "is logged in": "è loggato",
  "Is Partial": "È parziale",
  "is signed in": "è firmato in",
  "It's safe and encrypted - only used for password resets.": "È sicura e criptata — usata solo per il reset della password.",
  "Jan": "Gen",
  "Job vacancy": "Posto vacante",
  "Jul": "Lug",
  "Jun": "Giu",
  "KEY PEOPLE": "PERSONE CHIAVE",
  "Language": "Lingua",
  "Leave a comment about this timestamp and connected action.": "Lascia un commento su questa marca temporale e sull'azione correlata.",
  "Left Engine": "Motore sinistro",
  "Left Tail Wing": "Ala di coda sinistra",
  "Left Wing": "Ala sinistra",
  "Load Verification Cross-Check Form": "Modulo di controllo incrociato di verifica del carico",
  "Local (Under Wing / Local area contamination)": "Locale (Sotto l'ala / Contaminazione dell'area locale)",
  "Local Bags": "Borse locali",
  "Locked application": "Applicazione bloccata",
  "Log in": "Entrare",
  "Log out": "Disconnettersi",
  "Lost item": "Oggetto smarrito",
  "lowercase": "minuscole",
  "Mar": "Mar",
  "Mark location": "Contrassegnare la posizione",
  "May": "Mag",
  "Message archived": "Messaggio archiviato",
  "Message state": "Stato del messaggio",
  "Message type": "TIPO DI MESSAGGIO",
  "Message unarchived": "Messaggio non archiviato",
  "Messages": "Messaggi",
  "messages yet": "messaggi ancora",
  "min": "min",
  "Mix": "Mix",
  "Month": "Mese",
  "MVT History": "Cronologia MVT",
  "My profile": "Il mio profilo",
  "Name Surname": "Nome Cognome",
  "Neck": "Collo",
  "New password": "Nuova password",
  "New password cannot be equal to current": "La nuova password non può essere uguale a quella attuale.",
  "New password does not meet security requirements": "La nuova password non soddisfa i requisiti di sicurezza",
  "next": "prossimo",
  "Next 5 days": "Prossimi 5 giorni",
  "No": "No",
  "No active flights yet": "Aucun vol actif pour le moment",
  "No clocked times available": "Nessuna ora registrata disponibile",
  "No content yet...": "Nessun contenuto ancora...",
  "No flight details information": "Nessuna informazione sui dettagli del volo",
  "No instructions found": "Non sono state trovate istruzioni",
  "No internet connection": "Nessuna connessione a Internet",
  "No key people assigned.": "Nessuna persona chiave assegnata.",
  "No messages yet": "Nessun messaggio ancora",
  "No photo available": "Nessuna foto disponibile",
  "No photos here yet": "Nessuna foto qui ancora",
  "No registration": "Aucune inscription",
  "No services available": "Nessun servizio disponibile",
  "No time logging found": "Nessun registro di tempo trovato",
  "No timestamps configured for this flight type": "Nessun timestamp configurato per questo tipo di volo",
  "No types here yet": "Nessun tipo qui ancora",
  "no user data": "nessun dato utente",
  "None": "Nessuno",
  "Nose": "Naso",
  "Not completed": "Non completato",
  "Note": "Nota:",
  "Nov": "Nov",
  "NOW": "ORA",
  "Number of unread R&S:": "Numero di R&S non letti:",
  "numbers": "numeri",
  "occasion": "occasione",
  "Occasion": "Occasione",
  "Oct": "Ott",
  "Oops! It looks like your verification email didn't go through.": "Ops! Sembra che la tua email di verifica non sia andata a buon fine.",
  "Open": "Aperto",
  "Open a flight to add it to your active flights list.": "Ouvrez un vol pour l'ajouter à votre liste de vols actifs.",
  "Open file": "Aprire il file",
  "Open flight {{name}}": "Ouvrir le vol {{name}}",
  "Operation flight number": "Numero di volo operativo",
  "Operator's name": "Nome dell'operatore",
  "Operator's name:": "Nome dell'operatore:",
  "Operator's signature": "Firma dell'operatore",
  "Operator's signature:": "Firma dell'operatore:",
  "Optional": "Opzionale",
  "or": "o",
  "Origin": "Origine",
  "Other flights": "Altri voli",
  "Outside Air Temperature": "Temperatura dell'aria esterna (C°)",
  "Outside Air Temperature (C°)": "Temperatura dell'aria esterna (C°)",
  "Page not found": "Pagina non trovata",
  "Parking": "Parcheggio",
  "Partially (Wings & stabilizer only)": "Parzialmente (Solo ali e stabilizzatore)",
  "Password": "Password",
  "Password must be at least 8 characters": "La password deve essere lunga almeno 8 caratteri e contenere almeno 1 lettera maiuscola e 1 minuscola, 1 simbolo, 1 cifra e senza spazi bianchi.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Password non univoca. La nuova password non può essere una delle ultime 5 password utilizzate.",
  "Passwords do not match": "Le password non coincidono",
  "per occasion": "per occasione",
  "Per pax": "Per pax",
  "per start": "per avvio",
  "percent": "percentuale",
  "Photo registration": "Registrazione delle foto",
  "Photo types required": "Tipi di foto richiesti",
  "Photo types required:": "Tipi di foto richiesti:",
  "Photos": "Foto",
  "Pick if its a damaged part or lost item": "Scegliere se si tratta di una parte danneggiata o di un articolo perso",
  "Pin on schema": "Pin su schema",
  "Please briefly describe where you found the item": "Per favore, descrivi brevemente dove hai trovato l'articolo. Specificare la stanza o la linea e la fila se disponibile",
  "Please click here to proceed to flights list": "Cliccare qui per procedere alla lista dei voli",
  "Please make sure you attached photos of irregularities": "Assicurati di allegare foto delle irregolarità",
  "Please pick on scheme": "Si prega di scegliere lo schema",
  "Please reach out to your administrator for assistance": "Contatta il tuo amministratore per assistenza.",
  "Please try sending it again later.": "Si prega di riprovare a inviarla più tardi.",
  "Please try the link again.": "Si prega di riprovare il link.",
  "Please, sign below": "Per favore, firmate qui sotto",
  "Post-deicing/anti-icing check completed": "Verifica post-disgelo/anti-congelamento completata",
  "Precipitation": "Precipitazioni",
  "Pressure": "Pressione",
  "Proceed to login": "Procedere al login",
  "Product name": "Nome prodotto",
  "Product type": "Tipo prodotto",
  "Profile": "Profilo",
  "Profile data wasn't updated!": "I dati del profilo non sono stati aggiornati",
  "Psychosocial aid": "Assistenza psicossociale",
  "Quantity (liter)": "Quantità (litri)",
  "Read": "Leggere",
  "Read & Sign": "Leggere e firmare",
  "Read & Sign to do:": "Leggi e firma per fare:",
  "Read&Sign": "Leggi e firma",
  "Receive Extra shift requests": "Ricevi richieste di turni extra",
  "Receive job vacancies": "Ricevere le offerte di lavoro",
  recovery: {
    "error1": "<1>Ops!</1> Sembra che la tua e-mail di verifica non sia stata inviata.",
    "error2": "<1>Riprova più tardi.</1>",
    "error3": "Ci scusiamo per l'inconveniente.",
    "inUse": "Questa e-mail di recupero è già <1>in uso!</1>",
    "success": "L'<1>e-mail di verifica</1> è stata inviata con successo!",
    validation: {
      "blockedDomainNote": "Non sono accettate e-mail con <1>@aviapartner.aero</1> o <3>@aviavip.com</3>.",
      "invalidFormat": "Errore. L'e-mail non è nel formato standard."
    },
    "verified": "La tua e-mail di recupero è già <1>verificata!</1>"
  },
  "Recovery email": "E-mail di recupero",
  "Recovery email already verified!": "Email di recupero già verificata!",
  "Recovery email verified!": "Email di recupero verificata!",
  "Reg.": "Reg.",
  "Registration": "Registrazione",
  "Registration Closed": "Registrazione chiusa",
  "REGISTRATION CLOSED": "REGISTRAZIONE CHIUSA",
  "registration complete": "registrazione completa",
  "Remark": "Osservazione",
  "Remove": "Rimuovi",
  "Remove {{name}} from active flights": "Retirer {{name}} des vols actifs",
  "Reopen": "Riaprire",
  "reopen flight": "riaprire il volo",
  "Report any irregularities found upon arrival": "Segnala eventuali irregolarità trovate all'arrivo",
  "Report any other irregularities": "Segnala qualsiasi altra irregolarità",
  "Required": "Necessario",
  "required to close the flight": "E' necessario chiudere il volo",
  "Requirements of the password are not met.": "I requisiti della password non sono soddisfatti.",
  "Resend verification email": "Reinvia e-mail di verifica",
  "Right Engine": "Motore destro",
  "Right Tail Wing": "Ala di coda destra",
  "Right Wing": "Ala destra",
  "Runway": "Pista",
  "Safety Ramp Checklist": "Safety Ramp Checklist",
  "Safety Ramp Inspection": "Ispezione della rampa di sicurezza",
  "SAVE": "Salva",
  "save": "salva",
  "Save service registrations problem": "Salvare il problema delle registrazioni dei servizi",
  "Screening": "Screening",
  "Search": "Cerca",
  "Seat": "Sede",
  "Seats": "Posti a sedere",
  "Select type": "Selezionare il tipo",
  "SEND ARRIVAL MVT": "Invia MVT in arrivo",
  "SEND CORRECTION ARRIVAL MVT": "Invia COR MVT in arrivo",
  "Send the Arrival MVT message to recipients:": "Invia il MVT in arrivo ai destinatari:",
  "SENT": "INVIATO",
  "Sep": "Set",
  "Service info saved": "Informazioni di servizio salvate",
  "Service registration": "Registrazione del servizio",
  "Service registration is closed": "La registrazione al servizio è chiusa.",
  "Service Type": "Tipo di servizio",
  "Set": "Imposta",
  "Set date": "Imposta la data",
  "Set time": "Impostare il tempo",
  "Set time: End of anti-icing": "Imposta ora: Fine della anti-congelazione",
  "Set to now": "Impostare su ora",
  "Short remark": "Breve osservazione",
  "Show": "Mostra",
  "Show Photo": "Mostra foto",
  "Sign for understanding": "Segno di comprensione",
  "Sign form below to complete it": "Firma il form di cui sotto per completarlo:",
  "Sign in": "Accedi",
  "Sign out": "Disconnettiti",
  "Signed": "Firmato",
  "SKIP": "SALTA",
  "Skip this step": "Salta questo passo",
  "Something went wrong": "Qualcosa è andato storto",
  "Something went wrong. Please try again later.": "Si è verificato un errore. Riprova più tardi.",
  "Something wrong": "Qualcosa di sbagliato",
  "Sort.": "Ordina",
  "Specify where did you found the item": "Specifica dove hai trovato l'articolo",
  "Start": "Inizio",
  "Start anti-icing": "Inizio anti-icing",
  "Start Time": "Ora di inizio",
  "Station": "Stazione",
  "Stations": "Stazioni",
  "Stop anti-icing": "Fine anti-icing",
  "success": "successo",
  "Sunrise": "Alba",
  "Sunset": "Tramonto",
  "Switch flight": "Changer de vol",
  "symbols": "simboli",
  "SYSTEM SETTINGS": "IMPOSTAZIONI DI SISTEMA",
  "Tail": "Coda",
  "Take a photo": "Scattare una foto",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Scatta una foto di un'azione completata a cui è dedicato questo timestamp.",
  "Tap on area where damaged part is located": "Toccare l'area in cui si trova la parte danneggiata",
  "Task": "Compito",
  "Tasks & Flights": "Compiti e voli",
  "Telex messages": "Messaggi telex",
  "Temperature (C°)": "Temperatura (C°)",
  "The app has been updated": "L'applicazione è stata aggiornata",
  "The APPI code is required when resetting your Aviapartner": "Il codice APPI è necessario per reimpostare la password del suo account Aviapartner in Sunrise o attraverso l'helpdesk Aviapartner. Può sempre trovare il suo codice APPI nel suo profilo in Sunrise.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "Il codice APPI è necessario quando si reimposta la password dell'account Aviapartner in Sunrise o tramite l'assistenza clienti di Aviapartner. Puoi sempre trovare il tuo codice APPI nel tuo profilo in Sunrise.",
  "the correction MVT will be sent": "Dopo avere cliccato 'CONFERMA', il COR MVT verrà inviato. Potrà essere inviato nuovamente in caso di cambio a ALDT e/o AIBT.",
  "The current password you entered is incorrect.": "La password attuale inserita è errata.",
  "The current password you've entered is incorrect": "La password attuale che hai inserito non è corretta. Per favore ricontrolla e riprova.",
  "The elapsed time between": "Il tempo trascorso tra ",
  "The end time must be later than the start time.": "L'ora di fine deve essere successiva a quella di inizio.",
  "the MVT will be sent": "Dopo avere cliccato 'CONFERMA', il MVT verrà inviato. Potrà essere inviato nuovamente in caso di cambio a ALDT e/o AIBT.",
  "The planning shown below might not be up-to-date": "La pianificazione mostrata di seguito potrebbe non essere aggiornata.",
  "The shift is already confirmed to": "Il turno è già confermato a",
  "The username or password you've entered is incorrect": "Il nome utente o la password che hai inserito non sono corretti. Per favore ricontrolla e riprova. ",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "Il nome utente o la password che hai inserito non sono corretti. Si prega di ricontrollare e riprovare.",
  "The verification email has been sent successfully!": "L'email di verifica è stata inviata con successo!",
  "This action is mandatory.": "Questa azione è obbligatoria.",
  "This field is mandatory": "Questo campo è obbligatorio",
  "This form is signed": "Questo form è firmato",
  "This message is marked as urgent": "Questo messaggio è contrassegnato come urgente",
  "This recovery email is already in use!": "Questa email di recupero è già in uso!",
  "This request is not valid anymore": "Questa richiesta non è più valida",
  "This section is used to deal with visible damage to the airplane": "Questa sezione è usata per trattare i danni visibili dell'aereo. Si prega di documentare ogni problema visibile prima di eseguire qualsiasi servizio",
  "This service has been registered for this flight over 80% of the time.": "Questo servizio è stato registrato per questo volo più dell'80% delle volte.",
  "time": " tempo.",
  "Time registration": "Registrazione a tempo",
  "Timeline": "Cronologia",
  "Timestamp information": "Informazioni sul timestamp",
  "Timestamps type": "Tipo di timestamps",
  "to": "a",
  "To get a new one, simply follow these steps:": "Per ottenerne uno nuovo, segui semplicemente questi passaggi:",
  "Today": "Oggi",
  "TODAY": "OGGI",
  "Tomorrow": "Domani",
  "Transfer Bags": "Borse di trasferimento",
  "Truck Driver": "Camionista",
  "Truck driver's signature": "Firma del conducente del camion",
  "Truck driver's signature:": "Firma del camionista:",
  "Truck Number": "Numero del camion",
  "type": "tipo",
  "Type": "Tipo",
  "Unavailable": "Non disponibile",
  "Unread": "Non letto",
  "Until": "Fino a",
  "Unverified email": "E-mail non verificata!",
  "uppercase": "maiuscole",
  "Username": "Nome utente",
  "Username or email": "Nome utente o email",
  "validating": "convalida di",
  "validation": "convalida",
  "Verification Error": "Errore di verifica",
  "Verification Link Expired": "Link di verifica scaduto",
  "Verified email": "E-mail verificata",
  verify: {
    "alreadyVerifiedTitle": "Email di recupero già verificata!",
    "error1": "Si è verificato un errore durante la verifica del tuo indirizzo email.",
    "error2": "Per favore riprova il link.",
    "error3": "Se il problema persiste, vai su <1>Il mio profilo</1> per reinviare un nuovo link di verifica.",
    "errorTitle": "Errore di verifica",
    "expiredStep1": "Vai su <1>Il mio profilo</1> nel tuo account Sunrise.",
    "expiredStep2": "Trova la sezione di recupero account e clicca su \"Reinvia email di verifica\".",
    "expiredStepsIntro": "Per ottenerne uno nuovo, segui semplicemente questi passaggi:",
    "expiredTitle": "Link di verifica scaduto",
    "successDescription": "Ora puoi usarla per recuperare l'accesso al tuo account se dimentichi la password.",
    "successTitle": "Email di recupero verificata!",
    "verifying": "Verifica in corso..."
  },
  "Verifying...": "Verifica in corso...",
  "View key people": "Visualizza persone chiave",
  "Visibility": "Visibilità",
  "Visual checks must be performed AFTER GSE removal": "I controlli visivi devono essere eseguiti dopo la rimozione GSE",
  "Visual checks must be performed BEFORE GSE positioning": "I controlli visivi devono essere eseguiti prima del posizionamento GSE",
  "Walkaround Arrival Checklist": "Checklist Walkaround in arrivo",
  "Walkaround Pre-Departure Checklist": "Checklist Walkaround pre-partenza",
  "We apologize for the inconvenience.": "Ci scusiamo per l'inconveniente.",
  "We strongly recommend saving it in your smartphone phonebook": "Ti consigliamo vivamente di salvarlo nella rubrica del tuo smartphone in modo da avere sempre il codice APPI a portata di mano. Per salvare il codice, vai al tuo profilo Sunrise e scansiona il codice QR con il tuo smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Ti consigliamo vivamente di salvarlo nella rubrica del tuo smartphone in modo da avere sempre il codice APPI a portata di mano. Per salvare il codice, vai al tuo profilo Sunrise e scansiona il codice QR con il tuo smartphone.",
  "Weather": "Meteo",
  "Wind": "Vento",
  "Would you like to add it to your current registration?": "Vorresti aggiungerlo alla tua registrazione attuale?",
  "Write comment": "Scrivi un commento",
  "write new comment": "scrivere un nuovo commento",
  "Write your comment here, then press the green check mark": "Scrivi il tuo commento qui, poi premi il segno di spunta verde",
  "Year": "Anno",
  "Yes": "Sì",
  "Yesterday": "Ieri",
  "You are offline": "Sei offline.",
  "You can check your APPI code on Sunrise portal.": "Puoi controllare il tuo codice APPI sul portale Sunrise.",
  "You can now use it to regain access to your account if you forget your password.": "Ora puoi usarla per riacquistare l'accesso al tuo account se dimentichi la password.",
  "You can't remove this temporal item": "Non è possibile rimuovere questo elemento temporale",
  "You don't have permission to view clocked times": "Non hai il permesso di visualizzare le ore registrate",
  "You don't have permissions to take a photo": "Non si hanno i permessi per scattare una foto",
  "You were signed out automatically": "Sei stato disconnesso automaticamente. Il token è scaduto. Puoi riaccedere con le tue credenziali",
  "Your password and confirmation password do not match": "La tua password e la password di conferma non corrispondono.",
  "Your password has been changed successfully!": "La tua password è stata cambiata con successo!",
  "Your password has expired. Please compose a new password and log in again.": "La tua password è scaduta. Per favore, componi una nuova password e accedi di nuovo.",
  "Your password must contain at least eight characters": "La tua password deve contenere almeno otto caratteri, almeno un numero e lettere sia minuscole che maiuscole.",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "La tua password deve contenere almeno otto caratteri, almeno un numero e sia lettere minuscole che maiuscole.",
  "Your recovery email is already verified!": "La tua email di recupero è già stata verificata!",
  "Your session has expired. Please sign in again.": "La tua sessione è scaduta. Per favore, accedi di nuovo."
};
